<div class="card p-3 mb-4 flex flex-column gap-3">
    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
        <div class="flex flex-column gap-1">
            <h3 class="m-0 text-base font-bold">In process now</h3>
            <p class="m-0 text-sm text-color-secondary">
                Live crawl / analyze activity (state · district · year)
            </p>
        </div>
        <div class="flex align-items-center gap-3 text-xs text-color-secondary">
            @if (totalActive > 0) {
                <span class="font-semibold text-color">{{ totalActive }} active</span>
            }
            @if (lastUpdatedAt) {
                <span>Updated {{ updatedLabel() }}</span>
            }
            @if (loading && !data) {
                <span>Loading…</span>
            }
        </div>
    </div>

    @if (error && !data) {
        <div class="p-3 text-sm text-color-secondary border-1 border-dashed surface-border border-round">
            Could not load live pipeline activity.
        </div>
    } @else if (!loading && totalActive === 0) {
        <div class="p-3 text-sm text-color-secondary border-1 border-dashed surface-border border-round">
            No district crawl or analysis is running right now.
        </div>
    } @else if (totalActive > 0) {
        <div class="flex flex-column gap-2">
            @for (item of items; track item.run_id) {
                <div class="flex flex-wrap align-items-center gap-2 p-2 border-1 surface-border border-round surface-ground">
                    <p-tag [value]="phaseLabel(item)"
                           [severity]="phaseSeverity(item)"
                           styleClass="text-xs" />
                    <span class="font-bold text-sm">{{ item.state }}</span>
                    <span class="text-color-secondary text-sm">·</span>
                    <span class="text-sm font-semibold"
                          [pTooltip]="item.county ? ('County: ' + item.county) : ''"
                          tooltipPosition="top">
                        {{ item.district }}
                    </span>
                    <span class="text-color-secondary text-sm">·</span>
                    <span class="text-sm font-bold text-primary">{{ item.year }}</span>
                    @if (progressHint(item)) {
                        <span class="text-xs text-color-secondary ml-1">
                            {{ progressHint(item) }}
                        </span>
                    }
                    @if (startedLabel(item)) {
                        <span class="text-xs text-color-secondary ml-auto white-space-nowrap"
                              [pTooltip]="startedTooltip(item)"
                              tooltipPosition="top">
                            started {{ startedLabel(item) }}
                        </span>
                    }
                </div>
            }
        </div>
    }
</div>
